module.exports = __webpack_public_path__ + "static/media/gallery_21.33d92abd.png";